import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router } from '@angular/router';
import {Data} from './data';

@Component({
    selector: 'app-couponcode',
    templateUrl: './couponcode.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class CouponCodeComponent implements OnInit {


data=[];
i=1;
searchCouponText = '';
page : number =1;
branchModel : any;
companyModel ; any;
itemsTotalAdv : number =0;
enable = false;
objLoaderStatus: boolean = false;
blockedFlag : boolean = false;
message = '';
errormessage = '';
sortingOrder = [];
charFlag :boolean = false;
userId : number;
searchmessage = "";
 currentdate: number;
  expirein = [];
  column = "";

  numberColumn : number =0;
  order : string ="ASC";
  numberC
  statusFlag = false;

    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService,
    private router: Router,private dataCompany: Data) {
  var i=0;
  for(i=0;i<6;i++){
    this.sortingOrder[i] = true;
  }
    }

    ngOnInit() {
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
       this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');
this.currentdate =  Date.now();
       var i=0;
         var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllcoupon?currentSize=35&sortColumn=code&sortOrder=ASC", null, token).subscribe((result) => {
 
if(result.data){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    this.dataModulation(result.data);
     this.loaderService.displayLoader(false);

    }
      
     });
    }



    dataModulation(data){
            for(var i=0; i<data.length; i++){
   var getResult = this.calculateDiff(data[i].endDate,data[i].startDate);
                     var expire = this.convertDaysHour(data[i].startDate,getResult);
                      this.data[i].expiretime =expire;
           
      
        //  this.data[i].expiretime = this.expirein[i];
         if(this.data[i].expiretime == "0D 0H 0M 0S" || data[i].endDate == null || getResult<0){
           this.data[i].statusFlag = true;
         }
         else  if(data[i].status == 'ACTIVE'){
           this.data[i].statusFlag = false;
           this.data[i].enable = true;
         }
         else{
            this.data[i].statusFlag = false;
           this.data[i].enable = false;
         }

         this.companyModel = data.companyModel;
         this.branchModel = data.branchModel;
           }
      
    }

  calculateDiff(str1, str2) {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date(str1);
        var d = new Date();
      
        var secondDate = new Date(str2);
if(secondDate >d){
        var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
}
else{
  if(firstDate>d){
          var diffDays = Math.round(Math.abs((firstDate.getTime() - d.getTime()) / (oneDay)));
  }
  else{
    var diffDays = -1;
  }
}
        return diffDays;
    }
    getExpiryTimeString(d, h, m, s) {
        return  d + "D " + h + "H " + m + "M " + s + "S";
    }

     convertDaysHour(startAt, days = null) {
        let startdate = this.formatDate(startAt);
        let current = this.formatDate(this.currentdate);
                      var currentdate = new Date();

        if (startdate == current && days == 1) {
            var currentdate = new Date();
            return this.getExpiryTimeString(0, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
        } else {
            days = (days == null ? 0 : days);
            if(startdate == current){
            return this.getExpiryTimeString(days-1, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
          }
          else{
   if(startdate>current){
             return this.getExpiryTimeString(days,0,0,0);
            }
            else{
       return this.getExpiryTimeString(days, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
       
            }
                    }
            // this.campaign.expiretime=this.getExpiryTimeString(this.someRange,0,0,0);
        }
       
    
      }

         formatDate(date) {

        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

nextCoupon(text,id,order,event){
  var order;
  if(text){
  this.column = text;
}


if(id !== ''){
  this.numberColumn = id;
}

 var i=0;
  for(i=0;i<6;i++){
 
    if(this.numberColumn != i ){
    this.sortingOrder[i] = true;
  }
  }
if(order){
  this.order = order;
}
  
  

  if(this.order == 'DESC'){
this.sortingOrder[this.numberColumn] = false;
  }
  else{
this.sortingOrder[this.numberColumn] = true;
  }
    this.itemsTotalAdv =0;
    var j=0;
    this.page = event;
    var token = this.localstorage.getStorage("token");
    this.errormessage ="";
    this.searchmessage = "";
    this.searchCouponText = this.searchCouponText.trim();
    if(this.searchCouponText =='' || this.searchCouponText == undefined){
          this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/getAllcoupon?currentSize=35&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
         this.dataModulation(result.data);
      }
       else{
        this.searchmessage = "No records found";
      }
    this.loaderService.displayLoader(false);

}
  
         });
    } 
    else{
       if(this.searchCouponText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
         if(this.column == "discountValue"){
           this.column = "discount_Value";
         }
         else if(this.column == "maxDiscount"){
this.column = "max_Discount";
         }
                   this.loaderService.displayLoader(true);
      this.shareService.CallDatawithToken("admin/searchCoupon/"+this.searchCouponText+"?currentSize=35&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
     this.dataModulation(result.data);
    }
     else{
        this.searchmessage = "No records found";
      }
              this.loaderService.displayLoader(false);

    }
         });
    }
    }
    return event; 
    
    
        
}

createRoute(){
   this.dataCompany.storage = {
   
    "radioselected": true,
  }
       this.router.navigate(['/admin/couponCodes/createCoupon']);

}

companyInfoRoute(data){
  console.log(data);

  if(data.isAllCompaniesAllowed){
     this.dataCompany.storage = {
   
    "isAllCompaniesAllowed": true,
  }
         this.router.navigate(['/admin/couponCodes/companyInfo']);
  }
  else{
    this.dataCompany.storage = {
   
    "isAllCompaniesAllowed": false,
    "companyData":data.companyModel,
    "branchData":data.branchModel,

  }
       this.router.navigate(['/admin/couponCodes/companyInfo']);

  }
}

allCoupon(){
    this.page = 1;
  var i=0;
  for(i=0;i<6;i++){
    this.sortingOrder[i] = true;
  }
    var token = this.localstorage.getStorage("token");
  this.searchCouponText = '';
        this.itemsTotalAdv = 0;
 this.errormessage ="";
this.searchmessage ="";
   this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllcoupon?currentSize=35", null, token).subscribe((result) => {
   if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
         this.dataModulation(result.data);
      }
         this.loaderService.displayLoader(false);

         });
}


onChange(event,code){
var i=0;
      var token = this.localstorage.getStorage("token");

for(i=0;i<this.data.length;i++){

  if(this.data[i].code == code && event == true ){
  this.data[i].enable = true;
  this.shareService.CallDatawithToken("admin/toggleCouponStatus/"+code,{},token).subscribe((result) => {
  
    if(result.data && result.data.status == true){
         this.showActivated();
}
});


}
else if(this.data[i].code == code && event == false ){
   this.data[i].enable = false;
  this.shareService.CallDatawithToken("admin/toggleCouponStatus/"+code,{},token).subscribe((result) => {
  
    if(result.data && result.data.status == true){
         this.showDeactivated();
}
});


}
 
}
}




          showActivated() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Coupon Code Information', 
                message:'Coupon Activated Successfully',
              data: [],
             showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    
                });
        }

          showDeactivated() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Coupon Information', 
                message:'Coupon Deactivated Successfully',
              data: [],
             showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    
                });
        }

     

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/couponCode/couponcode.component.ts